import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import Finder from 'scoreboard/components/finder'
import FormView from 'scoreboard/components/form-view'
import template from './project-selector.hbs'
import ImagePicker from 'scoreboard/components/image-picker'
import projects from 'scoreboard/projects/projects'

/**
 * A project selector with projects in a list.
 * For a drop down select see render-project-dropdown.js
 */
const ProjectSelector = Backbone.View.extend({

	tagName: 'form',

	events: {
		'click .project': '_select'
	},

	/**
	 * Generic project selection dialog view
	 *
	 * @param {Array} [options.projects=projects.asArray()]	Array of projects to select from
	 * @param {Object} [options.wizard]	The wizard this project selection appears in
	 * @param {String} [options.titleCode='common.project.selectProject']	I18N code to display on title
	 *
	 */
	initialize(options = {}) {
		this.options = options
		this.projects = options.projects || projects.asArray()
		this.finder = new Finder()
		this.finder.on('find', this._find.bind(this))
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: false,
			submit: () => {
				let projectId = this.$('li.is-selected').data('id')
				if (this.options.wizard) {
					_.invoke(this.options.wizard, 'next', {projectId})
				} else {
					this.trigger('done', projectId)
				}
			}
		})
		this.titleCode = this.options.titleCode || 'common.project.selectProject'
	},

	render() {
		this.$el.empty().append(template(this))
		this.$('.finder').replaceWith(this.finder.el)
		this.finder.render()
		this._renderProjects(this.projects)
		if (this.options.wizard) {
			this.options.wizard.render({
				formView: this.formView
			})
		}
		this.formView.start()
		return this
	},

	_renderProjects: function (projectList) {
		const items = _.reduce(projectList, (html, p) => {
			html +=
				`<li class="project" data-id="${p.id}">
					<div class="content-wrapper">
						<div class="project-image-container">
							<img class="project-image" src="${p.logoPath != undefined ? p.logoPath : ImagePicker.imgSrc(null, projects.LOGO)}">
						</div>
						<h3>${_.escape(p.label)}</h3>
					</div>
				</li>`
			return html
		}, '')
		this.$('.list').html(items)
	},

	_select(e) {
		this.$('li').removeClass('is-selected')
		const projectEl = $(e.target).closest('li.project')
		projectEl.addClass('is-selected')
		const project = projects.get(projectEl.data('id'))
		this.formView.change(e)
		this.trigger('select', project)
		return project
	},

	_find(text) {
		let projects = this.projects
		if (!_.isEmpty(text)) {
			projects = _.filter(projects, p => _.includes(_.toLower(p.label), _.toLower(text)))
		}
		this._renderProjects(projects)
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.formView.remove()
	}

})

export default ProjectSelector

ProjectSelector.__filename__ = 'projects/project-selector.js'
